import CIN7Logo from './svgs/CIN7.svg';
import EcomDashLogo from './svgs/EcomDash.svg';
import FinaleLogo from './svgs/Finale.svg';
import FishbowlLogo from './svgs/Fishbowl.svg';
import SkuVaultLogo from './svgs/SkuVault.svg';
import ZenventoryLogo from './svgs/Zenventory.svg';
import { linkIDs } from '../../../../../../../../services/link-service/links';

/**
 * @typedef {object} IMSOption
 * @property {string} connectionId - Unique identifier for the IMS
 * @property {string} name - Display name of the IMS
 * @property {React.ComponentType} logo - SVG logo component
 * @property {string} helpArticleId - Link ID for help article
 */

/**
 * Data for IMS (Inventory Management System) options
 * @type {IMSOption[]}
 */
export const IMSData = [
  {
    connectionId: 'finale',
    name: 'Finale',
    logo: FinaleLogo,
    helpArticleId: linkIDs.FinaleInventory,
  },
  {
    connectionId: 'cin7',
    name: 'CIN7',
    logo: CIN7Logo,
    helpArticleId: linkIDs.CIN7Inventory,
  },
  {
    connectionId: 'skuvault',
    name: 'SkuVault',
    logo: SkuVaultLogo,
    helpArticleId: linkIDs.SkuVaultInventory,
  },
  {
    connectionId: 'ecomdash',
    name: 'EcomDash',
    logo: EcomDashLogo,
    helpArticleId: linkIDs.EcomDashInventory,
  },
  {
    connectionId: 'fishbowl',
    name: 'Fishbowl',
    logo: FishbowlLogo,
    helpArticleId: linkIDs.FishbowlInventory,
  },
  {
    connectionId: 'zenventory',
    name: 'Zenventory',
    logo: ZenventoryLogo,
    helpArticleId: linkIDs.ZenventoryInventory,
  },
];
